import { getTimezoneOffset } from 'date-fns-tz';
import moment from 'moment';
import PropTypes from 'prop-types';

// Formats a date-only JS Date (as produced by react-datepicker, always local midnight) as
// "YYYY-MM-DD" using LOCAL date parts, for sending to the API.
//
// Do not use `date.toISOString()` or `JSON.stringify(date)` on a raw Date for this purpose —
// both convert to UTC first, which silently shifts the date backward by one day for any user
// at a positive UTC offset (e.g. Europe/London during BST, UTC+1) whenever a Date object
// constructed at local midnight is submitted. moment(dateObject).format() reads the Date's own
// local getters (getFullYear/getMonth/getDate), matching what the user actually picked,
// regardless of the browser's timezone.
//
// Only pass an actual Date object here, not a "YYYY-MM-DD" string — moment parses dash-format
// date-only ISO strings as UTC (a separate, well-known moment quirk), which would reintroduce
// the same shift this function exists to prevent.
export var formatDateForApi = function formatDateForApi(date) {
  return moment(date).format('YYYY-MM-DD');
};
var endDate = function endDate(date, current) {
  if (current) {
    return 'Present';
  }
  if (date) {
    var dateArray = date.split('-').map(function (x) {
      return Number(x);
    });
    // Subtracted 1 to get the correct month
    return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]).toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }
  return null;
};

// .getDay() returns an int in [0..6]. 0 is Sunday, 6 is Saturday.
// so weekdays are the days for which .getDay() % 6 is non-zero.
export var isWeekday = function isWeekday(date) {
  return date.getDay() % 6 !== 0;
};

// calculates numBusinessDays (int) after the given initialDate (Date)
export var businessDaysAfter = function businessDaysAfter(initialDate, numBusinessDays) {
  var date = new Date(initialDate);
  var daysLeft = numBusinessDays;
  while (daysLeft) {
    date.setDate(date.getDate() + 1);
    if (isWeekday(date)) {
      daysLeft -= 1;
    }
  }
  return date;
};
var MS_PER_HOUR = 60 * 60 * 1000;

// e.g., "America/New_York" => "America/New York - (GMT-4:00)"
export var timezoneStringLabel = function timezoneStringLabel(tzStr) {
  var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  if (tzStr === 'seperator') {
    return tzStr;
  }
  var offsetInMS = getTimezoneOffset(tzStr, currentDate);
  var offsetInHours = offsetInMS / MS_PER_HOUR;
  var min = Math.abs(offsetInHours * 60);
  var minStr = min % 60 === 0 ? '00' : min % 60;
  var hrStr = Math.trunc(min / 60);
  var signStr = offsetInHours >= 0 ? '+' : '-';
  var offsetTimeStr = "".concat(signStr).concat(hrStr.toString().padStart(2, '0'), ":").concat(minStr);
  // e.g. offsetTimeStr = +4:30 or -2:00

  var tzLocality = tzStr.replace(/_/g, ' '); // replacing underscores with spaces
  tzLocality = tzLocality.replace('/', '-');
  return "".concat(tzLocality, "  (GMT").concat(offsetTimeStr, ")");
};
export var interviewAvailabilityShape = PropTypes.shape({
  date: PropTypes.string.isRequired,
  start_time: PropTypes.string.isRequired,
  end_time: PropTypes.string.isRequired
});
export var date = function date(start, end, current) {
  var startDateString = null;
  if (start) {
    var startDate = start.split('-').map(function (x) {
      return Number(x);
    });
    // Subtracted 1 to get the correct month
    startDateString = new Date(startDate[0], startDate[1] - 1, startDate[2]).toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric'
    });
  }
  var endDateString = endDate(end, current);
  if (startDateString || endDateString) {
    return "".concat(startDateString || '', " - ").concat(endDateString || '');
  }
  return null;
};
export default date;